import React, { VFC } from 'react';
import { css, keyframes } from '@emotion/css';
import { testimonials } from '../../constants/testimonials';

// 复制数据以确保循环滚动流畅 (复制2次足够)
const dataRepeated = [...testimonials, ...testimonials];

export const P6Section: VFC = () => {
  return (
    <section className={styles.wrapper} aria-label="P6">
      <h2 className={styles.title}>客户评价</h2>
      {/* <p className={styles.desc}>
        这是副标题文案这是副标题文案这是副标题文案这是副标题文案
      </p> */}
      <div className={styles.scrollContainer}>
        <div className={styles.scrollTrack}>
          {dataRepeated.map((t, i) => (
            <div key={i} className={styles.slide}>
              <div className={styles.card}>
                <div className={styles.contentWrapper}>
                  <p className={styles.content} dangerouslySetInnerHTML={{ __html: t.content }} />
                </div>
                <div className={styles.author}>
                  <div className={styles.name}>{t.name}</div>
                  <div className={styles.role}>{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// CSS动画：无缝循环滚动
const scrollAnimation = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const styles = {
  wrapper: css`
    pointer-events: none;
    position: relative;
    min-height: calc(var(--vh, 1vh) * 100);
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 6vh 0;
    width: min(1400px, 92vw);
    color: #fff;
  `,
  title: css`
    pointer-events: auto;
    text-align: center;
    font-size: 42px;
    font-weight: 800;
    margin: 0 0 5px 0;
    opacity: 0;
    transform: translate3d(30px, 0, 0);
    transition: opacity 0.7s ease, transform 0.7s ease;
    .reveal-visible & {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
    @media (max-width: 768px) {
      font-size: 32px;
    }
  `,
  desc: css`
    pointer-events: auto;
    text-align: center;
    margin: 0 auto;
    max-width: 760px;
    font-size: 20px;
    opacity: 0;
    transform: translate3d(-30px, 0, 0);
    transition: opacity 0.7s ease, transform 0.7s ease;
    .reveal-visible & {
      opacity: 0.9;
      transform: translate3d(0, 0, 0);
    }
    @media (max-width: 768px) {
      font-size: 15px;
      margin-bottom: 30px;
    }
  `,
  scrollContainer: css`
    pointer-events: auto;
    margin-top: 40px;
    width: 100%;
    overflow: hidden;
    opacity: 0;
    transition: opacity 0.7s ease 0.1s;

    .reveal-visible & {
      opacity: 1;
    }
  `,
  scrollTrack: css`
    display: flex;
    gap: 16px;
    animation: ${scrollAnimation} 40s linear infinite;
    width: fit-content;
    cursor: pointer;
    &:hover {
      animation-play-state: paused;
    }
  `,
  slide: css`
    width: 380px;
    height: 230px;
    flex-shrink: 0;
    display: flex;
    
    @media (max-width: 768px) {
      width: 280px;
      height: 180px;
    }
  `,
  card: css`
    width: 100%;
    height: 100%;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: #121619;
  `,
  contentWrapper: css`
    flex: 1;
    overflow-y: auto;
    margin-bottom: 16px;
    padding-right: 4px;
    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.05);
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 2px;

      &:hover {
        background: rgba(0, 0, 0, 0.3);
      }
    }
  `,
  content: css`
    margin: 0;
    line-height: 1.8;
    opacity: 0.88;
    font-size: 14px;
    color: #121619;
    
    strong {
      font-weight: 700;
      color: #121619;
      opacity: 1;
    }
  `,
  author: css`
    display: flex;
    align-items: center;
    gap: 8px;
    opacity: 0.95;
    flex-shrink: 0;
  `,
  name: css`
    font-weight: 700;
    font-size: 16px;
    color: #121619;
  `,
  role: css`
    font-weight: 700;
    font-size: 16px;
    color: #121619;
  `,
};
